import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface ShipmentData {
  id: string;
  bl_number: string;
  shipping_line: string;
  customer: string;
  origin: string;
  destination: string;
  vessel: string;
  voyage: string;
  departure_date: string | null;
  estimated_arrival: string | null;
  actual_arrival: string | null;
  container_count: number;
  last_updated: string;
  created_at?: string;
}

export const dbOperations = {
  async init() {
    try {
      const { data, error } = await supabase
        .from('shipments')
        .select('count');
      
      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Failed to initialize Supabase connection:', error);
      throw error;
    }
  },

  async storeShipments(shipments: Omit<ShipmentData, 'created_at'>[]) {
    const { error } = await supabase
      .from('shipments')
      .upsert(
        shipments.map(shipment => ({
          ...shipment,
          last_updated: new Date().toISOString()
        })),
        { 
          onConflict: 'id'
        }
      );

    if (error) {
      console.error('Error storing shipments:', error);
      throw error;
    }
  },

  async getShipments(): Promise<ShipmentData[]> {
    const { data, error } = await supabase
      .from('shipments')
      .select('*')
      .order('last_updated', { ascending: false });

    if (error) {
      console.error('Error fetching shipments:', error);
      throw error;
    }

    return data || [];
  },

  async clearShipments() {
    const { error } = await supabase
      .from('shipments')
      .delete()
      .neq('id', '');

    if (error) {
      console.error('Error clearing shipments:', error);
      throw error;
    }
  }
};